import { format } from "date-fns";
import { HEADER_HOUR_FORMAT } from "../appointment-schedule.constants.js";
const getWorkRange = (workingTimes) => {
  if (!workingTimes || !workingTimes.length)
    return [];
  const { start, end } = workingTimes[0];
  const initialValue = [start, end];
  const [earliestTime, latestTime] = workingTimes.reduce(([earliest, latest], current) => {
    const isCurrentStartEarlier = earliest.getTime() > current.start.getTime();
    const isCurrentEndLater = latest.getTime() < current.end.getTime();
    const newEarliest = isCurrentStartEarlier ? current.start : earliest;
    const newLatest = isCurrentEndLater ? current.end : latest;
    return [newEarliest, newLatest];
  }, initialValue);
  if (!earliestTime || !latestTime)
    return [];
  return [format(earliestTime, HEADER_HOUR_FORMAT), format(latestTime, HEADER_HOUR_FORMAT)];
};
export {
  getWorkRange
};
